export const clientOrderCollectionGuard = 'GET /reports/client-orders';
export const clientOrderResourceGuard = 'GET /reports/client-orders/d+';
